<script>
    import {createEventDispatcher} from 'svelte/internal';
    import {getDate, formatDate, setSubscriptionDates, sort} from "../lib/lib";
    import Alert from "../stores/alerts";
    import SubscriptionModal from "./SubscriptionModal.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";

    export let subscriptions;

    const dispatch = createEventDispatcher();

    let subscription = null;
    let viewSubscriptions = false;
    let subscriptionIndex = -1;

    const onAdd = () => {
        let start_year = null;
        let end_year = null;
        let action = 'add';

        if (subscriptions.length) {
            [start_year, end_year] = setSubscriptionDates(subscriptions[0].end_year);
            action = 'renew';
        } else {
            start_year = ~~formatDate(new Date, 'y');
            end_year = start_year + 1;
        }

        let index = 0;
        subscriptions.map(item => {
            if (item.index > index) {
                index = item.index;
            }
        });
        index++;

        subscription = {
            id: 0,
            index,
            start_year,
            end_year,
            date_at: getDate(),
            action,
        }
    }

    const onEdit = (item) => {
        subscriptionIndex = item.index;
        subscription = item;
        subscription.action = 'edit';
    }

    const onDelete = (item) => {
        Alert.delete("Διαγραφή συνδρομής", `Να διαγραφεί η συνδρομή από ${item.start_year} έως ${item.end_year} από το μέλος;`, () => {
            subscriptions = subscriptions.filter(x => x.index != item.index);
            if (subscriptionIndex == item.index) {
                subscriptionIndex = null;
            }
        });
    }

    const closeSubscription = (param) => {
        if (param) {
            let item = subscriptions.find(x => x.index == param.index);
            if (!item) {
                subscriptions = [param, ...subscriptions];
            } else {
                item.start_year = param.start_year;
                item.end_year = param.end_year;
                item.date_at = oaram.date_at;
                subscriptions = subscriptions;
            }
            dispatch("change");
        }

        subscriptions = sort(subscriptions, 'end_year', true);

        subscription = null;
    }

    const toggleSubscriptions = () => {
        viewSubscriptions = !viewSubscriptions;
    }
</script>
<div class="panel panel-default mb-4">
    <div class="panel-heading">
        Συνδρομές
    </div>
    {#if subscriptions.length}
        <table class="table table-list table-list-border-bottom table-sm">
            <thead>
            <tr>
                <th>ΕΝΑΡΞΗ</th>
                <th>ΛΗΞΗ</th>
                <th>ΗΜΕΡΟΜΗΝΙΑ</th>
                {#if viewSubscriptions}
                    <th></th>
                {/if}
            </tr>
            </thead>
            <tbody>
            {#each subscriptions as item, index}
                {#if index == 0 || viewSubscriptions}
                    <tr class="row-hover pointer" class:row-selected={ subscriptionIndex == item.index }
                        on:click={ () => onEdit(item) }>
                        <td>{ item.start_year }</td>
                        <td>{ item.end_year }</td>
                        <td class="date-column">{ formatDate(item.date_at, 'd-m-y') }</td>
                        {#if viewSubscriptions}
                            <td class="button-column pointer" title="διαγραφή συνδρομής"
                                on:click|preventDefault|stopPropagation="{ () => onDelete(item) }">
                                <AppIcon icon="trash" size="16"/>
                            </td>
                        {/if}
                    </tr>
                {/if}
            {/each}
            </tbody>
        </table>
        <div class="panel-body px-3 py-2">
            <div class="row">
                <div class="col-6">
                    <button class="btn btn-link ps-0" on:click={ onAdd }>
                        Ανανέωση συνδρομής
                    </button>
                </div>
                {#if subscriptions.length > 1}
                    <div class="col-6 text-end">
                        <button class="btn btn-link p3-0" on:click={ toggleSubscriptions }>
                            {#if !viewSubscriptions}
                                Εμφάνιση όλων
                            {:else}
                                Εμφάνιση τελευταίας
                            {/if}
                        </button>
                    </div>
                {/if}
            </div>
        </div>
    {:else}
        <div class="panel-body panel-pad">
            <p>
                Δεν υπάρχουν συνδρομές.
            </p>
            <button class="btn btn-link ps-0" on:click={ onAdd }>προσθήκη συνδρομής</button>
        </div>
    {/if}
</div>
{#if subscription}
    <SubscriptionModal {subscription} closeCallback="{ closeSubscription }"/>
{/if}